// Beta Report wording changes published from Admin → Beta Report Wording (2026-11-04).
// Wording only: questions, order, required and follow-ups stay in ./schema.js.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ENGLISH, setPublishedWording } from "./i18n";

export const GROUPS = ["ui", "stages", "sections", "ratings", "q", "opt"];
// Not editable: these take numbers, and the mode names are fixed product names.
export const LOCKED = new Set(["ui.stage", "ui.charsLeft", "ui.modes"]);

// Every editable text key ("q.a_overall", "opt.yes", …), in the built-in order.
export function editableKeys() {
  const keys = [];
  for (const group of GROUPS) {
    for (const [id, value] of Object.entries(ENGLISH[group] || {})) {
      const key = `${group}.${id}`;
      if (typeof value === "string" && !LOCKED.has(key)) keys.push(key);
    }
  }
  return keys;
}

export function textAt(strings, key) {
  const [group, id] = key.split(".");
  return strings?.[group]?.[id];
}

let loading = null;
let version = 0;
const listeners = new Set();

export function loadBetaReportWording({ force = false } = {}) {
  if (loading && !force) return loading;
  loading = api.get("/beta-report/wording")
    .then(({ data }) => {
      setPublishedWording(data?.text || {});
      version += 1;
      listeners.forEach((fn) => fn(version));
    })
    .catch(() => { loading = null; });
  return loading;
}

// Re-renders the caller once the published wording has loaded.
export function useBetaReportWording() {
  const [v, setV] = useState(version);
  useEffect(() => {
    listeners.add(setV);
    loadBetaReportWording();
    return () => listeners.delete(setV);
  }, []);
  return v;
}
